<template>
    <internal>
        <div class="p-6 bg-white border-b border-gray-200 overflow-y-scroll h-screen-80 shadow-sm sm:rounded-lg">
            <div class="flex justify-between">
                <div>
                    <p class="text-lg font-medium mb-4">Mark Student Attendance of :
                    <pre>{{ schedule.courseyear.duration.start_month }} > {{
                            schedule.courseyear.title
                        }} > {{ schedule.courseyear.course.title }} > {{
                            schedule.batch.title
                        }} Batch </pre>
                    </p>
                </div>
                <!-- <breeze-button class="mt-6 bg-red-700 border-red-600 hover:bg-red-800" @click="closeAdmissions()"> Close Admissions</breeze-button> -->
            </div>

            <breeze-table :searchable="true" :fields="fields" :items="admissions"
                          :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Schedule')"
                          :canCreate="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Schedule')">
                <template #check="data">
                    <input type="checkbox" class="rounded" v-model="selectedStudents" :value="data.item.id">
                </template>
                <template #roll_no="data">
                    {{ data.item.roll_no }}
                </template>
                <template #student="data">
                    {{ data.item.student.first_name }} {{ data.item.student.middle_name }}
                    {{ data.item.student.last_name }}
                </template>
            </breeze-table>
            <div class="flex space-x-4 mt-4">
                <div>
                    <BreezeLabel>Attendance Date</BreezeLabel>
                    <BreezeInput type="date" v-model="date"/>
                </div>
                <breeze-button :disabled="selectedStudents.length === 0" class="mt-6" @click="markAttendance">Mark
                    Attendance
                </breeze-button>
                <breeze-button :disabled="selectedStudents.length === 0" class="mt-6 bg-red-700 border-red-600 hover:bg-red-800" @click="closeAdmissions">
                    Close Admissions
                </breeze-button>
            </div>
        </div>
    </internal>
</template>

<script>
import Internal from '@/Pages/Internal/Internal'
import BreezeInput from '@/Components/Input'
import BreezeLabel from '@/Components/Label'
import ButtonLink from '@/Components/ButtonLink'
import CardHeader from '@/Components/CardHeader'
import {useForm} from '@inertiajs/inertia-vue3'
import BreezeInputError from '@/Components/InputError'
import BreezeButton from '@/Components/Button'
import BreezeCheckbox from '@/Components/Checkbox'
import Loading from '@/Components/Loading'
import SelectList from '@/Components/SelectList'
import Exception from '@/Components/Exception'
import BreezeTable from '@/Components/Table'
import {Inertia} from "@inertiajs/inertia";

export default {
    components: {
        Internal,
        BreezeInput,
        BreezeLabel,
        ButtonLink,
        CardHeader,
        BreezeInputError,
        BreezeButton,
        BreezeCheckbox,
        Loading,
        Exception,
        BreezeTable,
        SelectList
    },
    props: ['admissions', 'schedule'],
    data() {
        return {
            fields: [{'key': 'check', 'label': '#'}, {'key': 'roll_no', 'label': 'Roll No'}, {
                'key': 'student',
                'label': 'Student Name'
            }],
            branchid: localStorage.branchId,
            selectedStudents: [],
            date: new Date()
        }
    },
    methods: {
        markAttendance() {
            if (confirm('Are you sure to mark attendance for ' + this.selectedStudents.length + ' students out of ' + this.admissions.length + ' students?')) {
                Inertia.post(route('internal.weekschedule.students.markAttendance', [this.branchid, this.schedule.id]), {
                    admissions: this.selectedStudents,
                    date: this.date
                })
                    .then(res => {
                        console.log(res)
                    });
            }
        },
        closeAdmissions() {
            // if (confirm('Are you sure to close admission for ' + this.admissions.length + ' students?')) {
            //     Inertia.post(route('internal.weekschedule.students.closeAdmissions', [this.branchid, this.schedule.id]))
            //         .then(res => {
            //             console.log(res)
            //         });
            // }
            if (confirm('Are you sure to close admission for ' + this.selectedStudents.length + ' students out of ' + this.admissions.length + ' students?')) {
            Inertia.post(route('internal.weekschedule.students.closeAdmissions', [this.branchid, this.schedule.id]), {
                    admissions: this.selectedStudents,
                    date: this.date
                })
                    .then(res => {
                        console.log(res)
                    });
            }
        }
    }

}
</script>
